import {AxiosInstance} from "axios";
import {queryFile} from "../rest/restApi";

export function downloadFile(axios: AxiosInstance, url: string, mediaType?: string, params?: string) {
  return queryFile(axios, url, undefined, params, mediaType).then((file) => {
    // Bravely copied from https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios#53230807
    const url = window.URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file.name);
    document.body.appendChild(link);
    link.click();
  });
}

export function downloadFileAsObjectURL(axios: AxiosInstance, url: string, mediaType: string): Promise<string> {
  return queryFile(axios, url, undefined, undefined, mediaType).then((file) => {
    console.log("Retrieved file " + file.name + " of type " + file.type);
    let objectURL = window.URL.createObjectURL(file);
    console.log("Converted to uri: " + objectURL);
    return objectURL;
  });
}
